module.exports = __webpack_public_path__ + "img/es.95033b0d.png";